import React from "react";
import LazyMedia from "./LazyMedia";
import "./ProductCardMobile.css";
import PromoInfo from "./PromoInfo";
const ProductCardMobile = ({
  product,
  onTagClick,
  selectedTag,
  selectedCategory1,
  selectedCategory2,
  selectedCategory3
}) => {
  const handleCardClick = () => {
    if (!product.promotion_link) return;
    const newWindow = window.open(product.promotion_link, "_blank");
    if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
      // 팝업 차단 감지
      alert("팝업이 차단되었습니다. 직접 링크를 클릭하세요.");
    }
  };
  const originalPrice = parseFloat(product.target_original_price) || 0;
  const salePrice = parseFloat(product.target_sale_price) || 0;
  const revenue = parseFloat(product.revenue)/100000000 || 0;
  const lastest_volume = parseFloat(product.lastest_volume)/1000 || 0;


  const discount =
    originalPrice > 0
      ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
      : 0;
  const hasDiscount = discount > 0;

  const category1 = product.first_level_category_name;
  const category2 = product.second_level_category_name;
  const category3Keywords = product.keywords ? product.keywords.split(",") : [];

  // 해시태그 목록
  const hashtags = [category1, category2, ...category3Keywords].filter(Boolean);

  const handleTagClick = (e, tag) => {
    e.stopPropagation(); // ✅ 해시태그 클릭 시 부모 이벤트 차단
  
    if (tag === category1) {
      onTagClick(tag, "c1");
    } else if (tag === category2) {
      onTagClick(tag, "c2");
    } else {
      onTagClick(tag, "c3");
    }
  };
  return (
    <div
      className="product-card"
      onClick={handleCardClick}
      style={{ cursor: "pointer" }}
    >
      <div className="product-image-container">
        {/* ✅ 한국 배송 배지 (이미지 우측 상단 고정) */}
        {product.original_price_currency === "KRW" && (
          <div className="korean-product-badge">한국</div>
        )}
        
        {/* ✅ 상품 이미지 */}
        <LazyMedia
          src={product.product_main_image_url}
          alt={product.product_title}
          className="product-image"
        />
      </div>

      {/* ✅ 텍스트 영역 */}
      <div className="product-info">
        {product.promo_code_info && product.promo_code_info !== "nan" && (
          <PromoInfo promoInfo={product.promo_code_info} salePrice={salePrice} compact />
        )}
        <h3 className="product-name">{product.product_title}</h3>

        <p className="product-price">
          {hasDiscount && (
            <span className="original-price">
              {originalPrice.toLocaleString()}원
            </span>
          )}
          <span className="sale-price">{salePrice.toLocaleString()}원</span>
          {hasDiscount && <span className="discount-badge">🔥 {discount}%</span>}
        </p>

        {product.lastest_volume > 0 && (
          <p className="sales-volume">
            📦 {lastest_volume.toLocaleString("ko-KR", {minimumFractionDigits: 1,maximumFractionDigits: 1})}천개 판매 (
              {revenue.toLocaleString("ko-KR", { 
                minimumFractionDigits: 1, 
                maximumFractionDigits: 1 
              })}억원)
          </p>
        )}

        {/* ✅ 해시태그 */}
        <div className="product-hashtags">
          {hashtags.map((tag, index) => {
            const isSelected =
              tag === selectedTag ||
              tag === selectedCategory1 ||
              tag === selectedCategory2 ||
              tag === selectedCategory3;

            return (
              <button
                key={index}
                className={`hashtag ${isSelected ? "selected" : ""}`}
                onClick={(event) => handleTagClick(event, tag)}
              >
                #{tag} {isSelected && "❌"}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProductCardMobile);
